import { render, staticRenderFns } from "./monthlyPlafonPlan_detail.vue?vue&type=template&id=7a164438&"
import script from "./monthlyPlafonPlan_detail.vue?vue&type=script&lang=js&"
export * from "./monthlyPlafonPlan_detail.vue?vue&type=script&lang=js&"
import style0 from "./monthlyPlafonPlan_detail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports